
































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { DxPopup, DxSelectBox, DxButton, DxTextBox, DxScrollView } from 'devextreme-vue';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { DxResponsiveBox, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import {DxSwitch} from 'devextreme-vue/switch';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxScrolling,
  DxRequiredRule,
  DxNumericRule
} from 'devextreme-vue/data-grid';
import { FeeSheetRuleDto, FeeSheetRuleLevelEnum, FeeSheetRuleTypeEnum, FeeSheetRuleLevelNameEnum } from '@/models/Fees/FeeSheetRuleDto';
import { FeeSheetRowDto, FeeSheetRowTypeEnum } from '@/models/Fees/FeeSheetRowDto';
import { CountryDto } from '@/models/CountryDto';
import { FeeSheetModalType } from '@/models/Fees/FeeTypeEnum';
import { DataGrid } from '@questelservices/common-vue';
import Button from "devextreme/ui/button";
import _ from "lodash";
import { PhaseTypeService } from '../../service/PhaseTypeService';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { InfractionService } from '@/service/InfractionService';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import DxValidator, { DxRequiredRule  as RequiredRule} from 'devextreme-vue/validator';
import { DxForm } from 'devextreme-vue/form';
import SelectBox from "devextreme/ui/select_box";
import Form from "devextreme/ui/form";
import { PhaseAliasService } from '@/service/PhaseAliasService';
import { PhaseAliasDto } from '../../models/PhaseAliasDto';
import { alert } from 'devextreme/ui/dialog';

@Component({
  components: {
    DxPopup,
    DxHtmlEditor,
    DxItem,
    DxToolbarItem,
    DxResponsiveBox,
    DxLocation,
    DxCol,
    DxRow,
    DxToolbar,
    DxSelectBox,
    DxCheckBox,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxButton,
    DxLookup,
    DxScrolling,
    DxTextBox,
    DxRequiredRule,
    DxValidator,
    RequiredRule,
    DxForm,
    DxScrollView,
    DxNumericRule
  }
})
export default class FeeSheetRowDialog extends Vue {
    $refs: Vue['$refs'] & {
        phaseDataGrid?: DataGrid;
    } = {};

    @Prop()
    selectedPhasesInfraction!: any[];

    get thisSelectedPhasesInfraction() {
        return this.selectedPhasesInfraction;
    }

    set thisSelectedPhasesInfraction(value : any[]) {
        this.selectedPhasesInfraction = value;
    }
    
    @Prop()
    feeSheetRowTypeEnum!: FeeSheetRowTypeEnum;

    get thisFeeSheetRowType() {
        return this.feeSheetRowTypeEnum;
    }
    set thisFeeSheetRowType(value : FeeSheetRowTypeEnum){
        this.feeSheetRowTypeEnum = value;
    }

    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingModal();
    }

    @Watch("showDialog")
    onShowPropChange(value: boolean, oldValue: boolean) {
        if(value){
            this.processGetPhases();
            this.processFeeSheetRowType();
            this.addEventListeners();            
        }
        else {
            this.removeEventListeners();
        }
    }

    @Prop()
    feeSheetRow!: FeeSheetRowDto;

    get ThisFeeSheetRow() {
        return this.feeSheetRow;
    }

    set ThisFeeSheetRow(value:FeeSheetRowDto) {
        this.feeSheetRow = value;
    }

    @Prop()
    feeSheetRowType : FeeSheetModalType

    @Prop()
    countryList!: CountryDto[];

    dialogTitle: string;
    private phaseService: PhaseTypeService;
    private infractionService : InfractionService;
    private phaseAliasService: PhaseAliasService;
    
    typeList: Array<{ value: string, text: string }> = [ 
        { value: FeeSheetRuleTypeEnum.Cap, text: FeeSheetRuleTypeEnum.Cap },
        { value: FeeSheetRuleTypeEnum.Target, text: FeeSheetRuleTypeEnum.Target }
    ];
    errorVisible: boolean = false;
    errorMessage :string = '';
    errorMessageList: any = {
        duplication : "Duplication of row with same Country, Level and Type.",
        required : "Please provide necessary details in each row."
    }
    cantAdd: boolean = false;
    hasDuplication: boolean = false;
    forPhaseSelection: boolean;
    infractionList : InfractionTypeDto[];
    selectedPhase: any;
    selectedInfraction: any;
    phaseMultiPhaseTypes : Array<{ text: string, value: any, type:string }> = [];
    levelList: Array<{ value: number, text: string }> = [ 
        { value: FeeSheetRuleLevelEnum.NA, text: FeeSheetRuleLevelNameEnum.NA }, 
        { value: FeeSheetRuleLevelEnum.Level1, text: FeeSheetRuleLevelNameEnum.Level1 },
        { value: FeeSheetRuleLevelEnum.Level2, text: FeeSheetRuleLevelNameEnum.Level2 },
        { value: FeeSheetRuleLevelEnum.Level3, text: FeeSheetRuleLevelNameEnum.Level3 },
        { value: FeeSheetRuleLevelEnum.Level4, text: FeeSheetRuleLevelNameEnum.Level4 },
        { value: FeeSheetRuleLevelEnum.Level5, text: FeeSheetRuleLevelNameEnum.Level5 },
        { value: FeeSheetRuleLevelEnum.Level6, text: FeeSheetRuleLevelNameEnum.Level6 },
        { value: FeeSheetRuleLevelEnum.Level7, text: FeeSheetRuleLevelNameEnum.Level7 },
        { value: FeeSheetRuleLevelEnum.Level8, text: FeeSheetRuleLevelNameEnum.Level8 },
        { value: FeeSheetRuleLevelEnum.Level9, text: FeeSheetRuleLevelNameEnum.Level9 },
        { value: FeeSheetRuleLevelEnum.Level10, text: FeeSheetRuleLevelNameEnum.Level10 }
      
    ];
    thisIsForAdd : boolean;
    formValidationGroup: any;

    constructor() {
        super();
        this.dialogTitle = "Add"
        this.phaseService = new PhaseTypeService();
        this.infractionService = new InfractionService();
        this.phaseAliasService = new PhaseAliasService('/api/PhaseAlias');
        this.infractionList = [];
        this.phaseMultiPhaseTypes = [];
        this.feeSheetRowType = FeeSheetModalType.Add;
        this.thisIsForAdd = true;
        this.forPhaseSelection = true;
        this.selectedPhase = "";
        this.selectedInfraction = '';
     
    }

    addEventListeners(): void {
      document.addEventListener('keyup', this.onKeyup, true);
      document.addEventListener('keydown', this.onKeydown, true);
    }

    removeEventListeners(): void {
      document.removeEventListener('keyup', this.onKeyup, true);
      document.removeEventListener('keydown', this.onKeydown, true);
    }

    destroyed(): void {
      this.removeEventListeners();
    }

    onKeydown(e: any): void {
      if (e.key === 'Enter' && (e.ctrlKey || e.shiftKey)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    onKeyup(e: any): void {
      if (this.showingDialog && e.key === 'Enter' && (e.ctrlKey || e.shiftKey)) {
        e.preventDefault();
        e.stopPropagation();
        let buttonElement = document.getElementById("feeSheetRowDialogSaveButton");
        if(buttonElement) {
          buttonElement.click();
        }
      }
    }

    cancel(): void {
      this.hidingModal();
    }

    hidingModal(data: FeeSheetRowDto | undefined = undefined) : void {
        this.errorMessage = "";
        this.$emit("hidingFeeSheetRow", data);        
        if(!data){
            (this.$refs.phaseDataGrid as any).instance.cancelEditData();
        }
    }

    onPopupHidden(e:any): void {
        this.hasDuplication = false;
        this.cantAdd = false;
        this.selectedPhase = '';
        this.selectedInfraction = '';

        this.resetValidation();
    }

    onShowing(e:any): void {
        this.selectedPhase = this.ThisFeeSheetRow.PhaseTypeId;
        this.selectedInfraction = this.ThisFeeSheetRow.InfractionTypeId;
        this.resetValidation();
    }

    onPopupShown(e:any) : void {
        if(this.$refs.phaseDataGrid) {
            (this.$refs.phaseDataGrid as any).instance.clearSelection();
        }
    }

    resetValidation() {
        if(this.formValidationGroup) {
            this.formValidationGroup.reset();
        }
    }

    screen(width: number) {
        if(width < 640)
        return 'xs';
        else 
        return 'sm';
    }


    setAttr(name: string, value: any) : any {
        return Object.keys(this.$attrs).indexOf(name) > -1 ? this.$attrs[name] : value;
    }

    async getPhaseList(selected: any): Promise<any> {
        return await this.phaseService.getAll()
                .then((response : PhaseTypeDto[]) => {
                    let result = selected.length > 0 ?_.filter(response, (item:PhaseTypeDto) => {
                        let equality = _.find(selected, x => x === item.PhaseTypeId);
                     
                        return  equality || equality === 0 ? false : true;
                    }) : response;

                    let resp = result.map((p : PhaseTypeDto, index : number) => {
                            return { text: p.PhaseName, value: p.PhaseTypeId, type: 'Phase'}
                    });

                    return resp;
                })
                .catch(err => []);
    }

    async getInfractionList(selected: any) : Promise<InfractionTypeDto[]> {
        return await this.infractionService.GetAllInfractionTypes()
                .then((response : InfractionTypeDto[]) => {
                        let result = selected.length > 0 ? _.filter(response, (item:InfractionTypeDto) => {
                            return _.find(selected, x => x === item.InfractionTypeId) ? false : true;
                        }): response;

                        return result;
                })
                .catch(err => []);
    }

    async getMultiPhaseList(selected: any) : Promise<any> {
        return await this.phaseAliasService.getAll(_.filter(selected, item => typeof(item) === 'string'))
                .then((response: PhaseAliasDto[]) => {
                        let result = selected.length > 0 ? _.filter(response, (item:PhaseAliasDto) => {
                                return _.find(selected, x => x === item.PhaseAliasId) ? false : true;
                        }): response;

                        let resp = result.map((p : PhaseAliasDto, index : number) => {
                            return { text: p.Name, value: p.PhaseAliasId, type: 'Alias'}
                        });

                        return resp;
                })
                .catch(err => []);
    }

    async processGetPhases() {
        this.forPhaseSelection = this.thisFeeSheetRowType === FeeSheetRowTypeEnum.Phase ? true : false;
        let selected = this.thisSelectedPhasesInfraction;
        if(this.forPhaseSelection) {
            this.selectedPhase = "";
            this.infractionList = [];
            let pTypes = await this.getPhaseList(selected);
            let mTypes = await this.getMultiPhaseList(selected);

            this.phaseMultiPhaseTypes = _.concat(pTypes, mTypes);
            if(this.ThisFeeSheetRow.PhaseType) {
                this.selectedPhase = this.ThisFeeSheetRow.PhaseType.PhaseTypeId;                
            }
            else if(this.ThisFeeSheetRow.PhaseAlias){
                this.selectedPhase = this.ThisFeeSheetRow.PhaseAlias.PhaseAliasId;
            }
        }
        else {
            this.phaseMultiPhaseTypes = [];

            this.infractionList = await this.getInfractionList(selected);

            if(this.ThisFeeSheetRow.InfractionType){
                this.ThisFeeSheetRow.InfractionTypeId = this.ThisFeeSheetRow.InfractionType.InfractionTypeId;
                this.selectedInfraction = this.ThisFeeSheetRow.InfractionType.InfractionTypeId;
            }
        }
    }

    processFeeSheetRowType(): void {
        if(this.feeSheetRowType === FeeSheetModalType.Update) {
            this.thisIsForAdd = false;
            this.dialogTitle = "Update";
        }
        else {
            this.thisIsForAdd = true;
            this.dialogTitle = "Add";
        }
    }

    onAddFeeSheetRule(e:any): void {        
        let newRule: FeeSheetRuleDto = {
            FeeSheetRuleId: "00000000-0000-0000-0000-000000000000",
            FeeSheetRowId: this.feeSheetRow.FeeSheetRowId,
            CountryId: 0,
            Notes: "",
            Level: 0,
            Type: "Cap",
            Amount: 0,
            CountryCode: "",
            Signed: false,
            InJurisdiction: false,
            FilingTypes: []
        };

        let toAdd = _.cloneDeep(newRule);
        this.ThisFeeSheetRow.FeeSheetRules.unshift(toAdd);

        this.checkCanSaveAndAdd();
    }

    onCellEdit(e:any) : void {
        (this.$refs.phaseDataGrid as any).instance.saveEditData();
    }

    checkValue(newValue: any, oldValue:any, prop:string) {
        if(newValue.hasOwnProperty(prop) && 
                    oldValue.hasOwnProperty(prop) && 
                    newValue[prop] === oldValue[prop]
        ){
            return true;
        }

        return false;
    }

    onRowUpdatedEvent(e:any) : void {
       this.checkCanSaveAndAdd();
    }

    checkIfHasDuplicationOfRules() : boolean {
        let result = false;

        let currentRules = _.cloneDeep(this.feeSheetRow.FeeSheetRules);
        //Will include type once decided to be included
        let removeDuplication = currentRules.filter((obj, pos, arr) => {
            let fil = _.filter(arr, item => item.CountryId == obj.CountryId && item.Type == obj.Type && item.Level == obj.Level)
            return fil.length == 1;
        });

        if(removeDuplication.length !== this.feeSheetRow.FeeSheetRules.length){
            result = true;
        }
        
        return result;
    }



    checkFeeSheetRulesData(): boolean {        
        if(_.find(this.feeSheetRow.FeeSheetRules, (item : FeeSheetRuleDto) => 
            (item.CountryId == undefined) || !item.Type || item.Level == null || item.Amount < 0
        )) {
            return true;
        }
        return false
    }

    deleteBtnClicked(data: any): void {
        if(!this.feeSheetRow.DeletedFeeSheetRules) {
            this.feeSheetRow.DeletedFeeSheetRules = [];
        }

        if(data.data.FeeSheetRuleId != "00000000-0000-0000-0000-000000000000" && data.data.FeeSheetRuleId) {
            this.feeSheetRow.DeletedFeeSheetRules.push(data.data);
        }
        
        this.feeSheetRow.FeeSheetRules.splice(data.rowIndex, 1);

        this.checkCanSaveAndAdd();
    }

    checkCanSaveAndAdd() : void {
        let requiredData = this.checkFeeSheetRulesData();
        let dup = this.checkIfHasDuplicationOfRules();

        this.cantAdd = requiredData || dup;
        this.hasDuplication = dup;


       if(requiredData) {
           this.errorMessage = this.errorMessageList.required;
       } 
       else if(dup) {
           this.errorMessage = this.errorMessageList.duplication;
       }
       else {
           this.errorMessage = "";
       }
    }

    save(e:any) {  
        if(!this.showingDialog) {
            return;
        }

        //Validation for phase and infraction
        if(this.forPhaseSelection) {
            if(this.selectedPhase == null) {
                alert("Please select a valid Phase", "Invalid Phase");
                return;
            }
        }
        else {
            if(this.selectedInfraction == null) {
                alert("Please select a valid Infraction", "Invalid Infraction");
                return;
            }
        }        

        if(this.hasDuplication) {
            this.errorMessage = this.errorMessageList.duplication;
            return;
        }

        if(this.checkFeeSheetRulesData()) {
            this.errorMessage = this.errorMessageList.required;
            return;
        }

        (this.$refs.phaseDataGrid as any).instance.saveEditData();
        let payload = _.cloneDeep(this.feeSheetRow);        
        

        if(this.forPhaseSelection) {
            let selectedPhaseMultiPhase = _.find(this.phaseMultiPhaseTypes, item => item.value === this.selectedPhase);

            if(selectedPhaseMultiPhase) {
                if(selectedPhaseMultiPhase.type === "Phase") {
                    payload.PhaseAliasId = undefined;
                    payload.PhaseAlias = undefined;
                    payload.PhaseTypeId = selectedPhaseMultiPhase.value;
                    payload.PhaseType = {
                        PhaseTypeId: selectedPhaseMultiPhase.value,
                        PhaseName: selectedPhaseMultiPhase.text,
                        PhaseVerb: "",
                        RgbHex: "",
                        PhaseOrder: 0,
                        SecondaryPhaseOrder: null,
                        IsBatched: false
                    }
                }
                else {
                    payload.PhaseTypeId = undefined;
                    payload.PhaseType = undefined;
                    payload.PhaseAlias = {
                        Name: selectedPhaseMultiPhase.text,
                        PhaseAliasId: selectedPhaseMultiPhase.value,
                        PhaseTypeIds: []
                    }
                    payload.PhaseAliasId = selectedPhaseMultiPhase.value
                }
            }

        }
        else {
            payload.InfractionTypeId = this.selectedInfraction;
            payload.InfractionType = _.find(this.infractionList, 
                (item: InfractionTypeDto) => item.InfractionTypeId == payload.InfractionTypeId);
        }
       
        
        this.hidingModal(payload);
        this.resetValidation();
    }
}
